export interface Route {
  path: string;
  title: string;
  component: JSX.Element | null;
  hideFromModal?: boolean;
  numpadCode: string;
}

let baseCode = 0;
// eslint-disable-next-line no-plusplus
const nextCode = () => (baseCode++).toString().padStart(4, "0");

export const extendRoutes = (routes: Omit<Route, "numpadCode">[]): Route[] =>
  routes.map((route) => ({ ...route, numpadCode: nextCode() }));
